import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SortBy = /*#__PURE__*/function (SortBy) {
  SortBy[SortBy["SORT_BY_NOT_SPECIFIED"] = 0] = "SORT_BY_NOT_SPECIFIED";
  SortBy[SortBy["SORT_BY_UPDATED_AT"] = 1] = "SORT_BY_UPDATED_AT";
  SortBy[SortBy["SORT_BY_CREATED_AT"] = 2] = "SORT_BY_CREATED_AT";
  SortBy[SortBy["SORT_BY_PRIORITY"] = 3] = "SORT_BY_PRIORITY";
  SortBy[SortBy["SORT_BY_STATUS"] = 4] = "SORT_BY_STATUS";
  SortBy[SortBy["SORT_BY_TICKET_TYPE"] = 5] = "SORT_BY_TICKET_TYPE";
  return SortBy;
}(SortBy || {});
var SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder[SortOrder["SORT_ORDER_NOT_SPECIFIED"] = 0] = "SORT_ORDER_NOT_SPECIFIED";
  SortOrder[SortOrder["SORT_ORDER_ASC"] = 1] = "SORT_ORDER_ASC";
  SortOrder[SortOrder["SORT_ORDER_DESC"] = 2] = "SORT_ORDER_DESC";
  return SortOrder;
}(SortOrder || {});
var Status = /*#__PURE__*/function (Status) {
  Status[Status["STATUS_NOT_SPECIFIED"] = 0] = "STATUS_NOT_SPECIFIED";
  Status[Status["STATUS_NEW"] = 1] = "STATUS_NEW";
  Status[Status["STATUS_OPEN"] = 2] = "STATUS_OPEN";
  Status[Status["STATUS_PENDING"] = 3] = "STATUS_PENDING";
  Status[Status["STATUS_HOLD"] = 4] = "STATUS_HOLD";
  Status[Status["STATUS_SOLVED"] = 5] = "STATUS_SOLVED";
  Status[Status["STATUS_CLOSED"] = 6] = "STATUS_CLOSED";
  return Status;
}(Status || {});
// *********************************

function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Article {
  static fromProto(proto) {
    let m = new Article();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class Attachment {
  static fromProto(proto) {
    let m = new Attachment();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.size) {
      m.size = parseInt(proto.size, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.fileName !== 'undefined') {
      toReturn['fileName'] = this.fileName;
    }
    if (typeof this.contentUrl !== 'undefined') {
      toReturn['contentUrl'] = this.contentUrl;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    if (typeof this.size !== 'undefined') {
      toReturn['size'] = this.size;
    }
    if (typeof this.inline !== 'undefined') {
      toReturn['inline'] = this.inline;
    }
    return toReturn;
  }
}
class Group {
  static fromProto(proto) {
    let m = new Group();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.updatedAt) {
      m.updatedAt = new Date(proto.updatedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.deleted !== 'undefined') {
      toReturn['deleted'] = this.deleted;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined' && this.updatedAt !== null) {
      toReturn['updatedAt'] = 'toApiJson' in this.updatedAt ? this.updatedAt.toApiJson() : this.updatedAt;
    }
    return toReturn;
  }
}
class Ticket {
  static fromProto(proto) {
    let m = new Ticket();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.organizationId) {
      m.organizationId = parseInt(proto.organizationId, 10);
    }
    if (proto.requester) {
      m.requester = User.fromProto(proto.requester);
    }
    if (proto.collaborators) {
      m.collaborators = proto.collaborators.map(User.fromProto);
    }
    if (proto.dueAt) {
      m.dueAt = new Date(proto.dueAt);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.updatedAt) {
      m.updatedAt = new Date(proto.updatedAt);
    }
    if (proto.followupSourceId) {
      m.followupSourceId = parseInt(proto.followupSourceId, 10);
    }
    if (proto.assignee) {
      m.assignee = User.fromProto(proto.assignee);
    }
    if (proto.group) {
      m.group = Group.fromProto(proto.group);
    }
    if (proto.via) {
      m.via = Via.fromProto(proto.via);
    }
    if (proto.comment) {
      m.comment = TicketComment.fromProto(proto.comment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.priority !== 'undefined') {
      toReturn['priority'] = this.priority;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    if (typeof this.requester !== 'undefined' && this.requester !== null) {
      toReturn['requester'] = 'toApiJson' in this.requester ? this.requester.toApiJson() : this.requester;
    }
    if (typeof this.collaborators !== 'undefined' && this.collaborators !== null) {
      toReturn['collaborators'] = 'toApiJson' in this.collaborators ? this.collaborators.toApiJson() : this.collaborators;
    }
    if (typeof this.dueAt !== 'undefined' && this.dueAt !== null) {
      toReturn['dueAt'] = 'toApiJson' in this.dueAt ? this.dueAt.toApiJson() : this.dueAt;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined' && this.updatedAt !== null) {
      toReturn['updatedAt'] = 'toApiJson' in this.updatedAt ? this.updatedAt.toApiJson() : this.updatedAt;
    }
    if (typeof this.recipient !== 'undefined') {
      toReturn['recipient'] = this.recipient;
    }
    if (typeof this.followupSourceId !== 'undefined') {
      toReturn['followupSourceId'] = this.followupSourceId;
    }
    if (typeof this.assignee !== 'undefined' && this.assignee !== null) {
      toReturn['assignee'] = 'toApiJson' in this.assignee ? this.assignee.toApiJson() : this.assignee;
    }
    if (typeof this.group !== 'undefined' && this.group !== null) {
      toReturn['group'] = 'toApiJson' in this.group ? this.group.toApiJson() : this.group;
    }
    if (typeof this.via !== 'undefined' && this.via !== null) {
      toReturn['via'] = 'toApiJson' in this.via ? this.via.toApiJson() : this.via;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.comment !== 'undefined' && this.comment !== null) {
      toReturn['comment'] = 'toApiJson' in this.comment ? this.comment.toApiJson() : this.comment;
    }
    return toReturn;
  }
}
class TicketComment {
  static fromProto(proto) {
    let m = new TicketComment();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.authorId) {
      m.authorId = parseInt(proto.authorId, 10);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.htmlBody !== 'undefined') {
      toReturn['htmlBody'] = this.htmlBody;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    if (typeof this.authorId !== 'undefined') {
      toReturn['authorId'] = this.authorId;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    return toReturn;
  }
}
class User {
  static fromProto(proto) {
    let m = new User();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.updatedAt) {
      m.updatedAt = new Date(proto.updatedAt);
    }
    if (proto.localeId) {
      m.localeId = parseInt(proto.localeId, 10);
    }
    if (proto.lastLoginAt) {
      m.lastLoginAt = new Date(proto.lastLoginAt);
    }
    if (proto.organizationId) {
      m.organizationId = parseInt(proto.organizationId, 10);
    }
    if (proto.customRoleId) {
      m.customRoleId = parseInt(proto.customRoleId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.alias !== 'undefined') {
      toReturn['alias'] = this.alias;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined' && this.updatedAt !== null) {
      toReturn['updatedAt'] = 'toApiJson' in this.updatedAt ? this.updatedAt.toApiJson() : this.updatedAt;
    }
    if (typeof this.active !== 'undefined') {
      toReturn['active'] = this.active;
    }
    if (typeof this.verified !== 'undefined') {
      toReturn['verified'] = this.verified;
    }
    if (typeof this.shared !== 'undefined') {
      toReturn['shared'] = this.shared;
    }
    if (typeof this.sharedAgent !== 'undefined') {
      toReturn['sharedAgent'] = this.sharedAgent;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.localeId !== 'undefined') {
      toReturn['localeId'] = this.localeId;
    }
    if (typeof this.timeZone !== 'undefined') {
      toReturn['timeZone'] = this.timeZone;
    }
    if (typeof this.lastLoginAt !== 'undefined' && this.lastLoginAt !== null) {
      toReturn['lastLoginAt'] = 'toApiJson' in this.lastLoginAt ? this.lastLoginAt.toApiJson() : this.lastLoginAt;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.signature !== 'undefined') {
      toReturn['signature'] = this.signature;
    }
    if (typeof this.details !== 'undefined') {
      toReturn['details'] = this.details;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    if (typeof this.role !== 'undefined') {
      toReturn['role'] = this.role;
    }
    if (typeof this.customRoleId !== 'undefined') {
      toReturn['customRoleId'] = this.customRoleId;
    }
    if (typeof this.moderator !== 'undefined') {
      toReturn['moderator'] = this.moderator;
    }
    if (typeof this.ticketRestriction !== 'undefined') {
      toReturn['ticketRestriction'] = this.ticketRestriction;
    }
    if (typeof this.onlyPrivateComments !== 'undefined') {
      toReturn['onlyPrivateComments'] = this.onlyPrivateComments;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.restrictedAgent !== 'undefined') {
      toReturn['restrictedAgent'] = this.restrictedAgent;
    }
    if (typeof this.suspended !== 'undefined') {
      toReturn['suspended'] = this.suspended;
    }
    return toReturn;
  }
}
class Via {
  static fromProto(proto) {
    let m = new Via();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateTicketRequest {
  static fromProto(proto) {
    let m = new CreateTicketRequest();
    m = Object.assign(m, proto);
    if (proto.ticket) {
      m.ticket = Ticket.fromProto(proto.ticket);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ticket !== 'undefined' && this.ticket !== null) {
      toReturn['ticket'] = 'toApiJson' in this.ticket ? this.ticket.toApiJson() : this.ticket;
    }
    return toReturn;
  }
}
class CreateTicketResponse {
  static fromProto(proto) {
    let m = new CreateTicketResponse();
    m = Object.assign(m, proto);
    if (proto.ticket) {
      m.ticket = Ticket.fromProto(proto.ticket);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ticket !== 'undefined' && this.ticket !== null) {
      toReturn['ticket'] = 'toApiJson' in this.ticket ? this.ticket.toApiJson() : this.ticket;
    }
    return toReturn;
  }
}
class GetArticleRequest {
  static fromProto(proto) {
    let m = new GetArticleRequest();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetArticleResponse {
  static fromProto(proto) {
    let m = new GetArticleResponse();
    m = Object.assign(m, proto);
    if (proto.article) {
      m.article = Article.fromProto(proto.article);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.article !== 'undefined' && this.article !== null) {
      toReturn['article'] = 'toApiJson' in this.article ? this.article.toApiJson() : this.article;
    }
    return toReturn;
  }
}
class GetUserByPhoneRequest {
  static fromProto(proto) {
    let m = new GetUserByPhoneRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.number !== 'undefined') {
      toReturn['number'] = this.number;
    }
    return toReturn;
  }
}
class GetUserByPhoneResponse {
  static fromProto(proto) {
    let m = new GetUserByPhoneResponse();
    m = Object.assign(m, proto);
    if (proto.user) {
      m.user = User.fromProto(proto.user);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    if (typeof this.pid !== 'undefined') {
      toReturn['pid'] = this.pid;
    }
    return toReturn;
  }
}
class ListCommentsRequest {
  static fromProto(proto) {
    let m = new ListCommentsRequest();
    m = Object.assign(m, proto);
    if (proto.ticketId) {
      m.ticketId = parseInt(proto.ticketId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ticketId !== 'undefined') {
      toReturn['ticketId'] = this.ticketId;
    }
    return toReturn;
  }
}
class ListCommentsResponse {
  static fromProto(proto) {
    let m = new ListCommentsResponse();
    m = Object.assign(m, proto);
    if (proto.comments) {
      m.comments = proto.comments.map(TicketComment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.comments !== 'undefined' && this.comments !== null) {
      toReturn['comments'] = 'toApiJson' in this.comments ? this.comments.toApiJson() : this.comments;
    }
    return toReturn;
  }
}
class ListTicketsRequest {
  static fromProto(proto) {
    let m = new ListTicketsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListTicketsResponse {
  static fromProto(proto) {
    let m = new ListTicketsResponse();
    m = Object.assign(m, proto);
    if (proto.tickets) {
      m.tickets = proto.tickets.map(Ticket.fromProto);
    }
    if (proto.users) {
      m.users = proto.users.map(User.fromProto);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tickets !== 'undefined' && this.tickets !== null) {
      toReturn['tickets'] = 'toApiJson' in this.tickets ? this.tickets.toApiJson() : this.tickets;
    }
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class SearchTicketsRequest {
  static fromProto(proto) {
    let m = new SearchTicketsRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(Status, proto.status);
    }
    if (proto.sortBy) {
      m.sortBy = enumStringToValue(SortBy, proto.sortBy);
    }
    if (proto.sortOrder) {
      m.sortOrder = enumStringToValue(SortOrder, proto.sortOrder);
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(Status, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.sortBy !== 'undefined') {
      toReturn['sortBy'] = this.sortBy;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.sortOrder !== 'undefined') {
      toReturn['sortOrder'] = this.sortOrder;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    return toReturn;
  }
}
class SearchTicketsResponse {
  static fromProto(proto) {
    let m = new SearchTicketsResponse();
    m = Object.assign(m, proto);
    if (proto.tickets) {
      m.tickets = proto.tickets.map(Ticket.fromProto);
    }
    if (proto.users) {
      m.users = proto.users.map(User.fromProto);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tickets !== 'undefined' && this.tickets !== null) {
      toReturn['tickets'] = 'toApiJson' in this.tickets ? this.tickets.toApiJson() : this.tickets;
    }
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'support-api.vendasta-local.com',
  'test': '',
  'demo': 'support-api-demo.apigateway.co',
  'prod': 'support-api-prod.apigateway.co',
  'production': 'support-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SupportApiService = /*#__PURE__*/(() => {
  class SupportApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createTicket(r) {
      const request = r.toApiJson ? r : new CreateTicketRequest(r);
      return this.http.post(this._host + "/support.v1.Support/CreateTicket", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateTicketResponse.fromProto(resp)));
    }
    getUserByPhone(r) {
      const request = r.toApiJson ? r : new GetUserByPhoneRequest(r);
      return this.http.post(this._host + "/support.v1.Support/GetUserByPhone", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUserByPhoneResponse.fromProto(resp)));
    }
    listTickets(r) {
      const request = r.toApiJson ? r : new ListTicketsRequest(r);
      return this.http.post(this._host + "/support.v1.Support/ListTickets", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTicketsResponse.fromProto(resp)));
    }
    listComments(r) {
      const request = r.toApiJson ? r : new ListCommentsRequest(r);
      return this.http.post(this._host + "/support.v1.Support/ListComments", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCommentsResponse.fromProto(resp)));
    }
    searchTickets(r) {
      const request = r.toApiJson ? r : new SearchTicketsRequest(r);
      return this.http.post(this._host + "/support.v1.Support/SearchTickets", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchTicketsResponse.fromProto(resp)));
    }
    getArticle(r) {
      const request = r.toApiJson ? r : new GetArticleRequest(r);
      return this.http.post(this._host + "/support.v1.Support/GetArticle", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetArticleResponse.fromProto(resp)));
    }
  }
  SupportApiService.ɵfac = function SupportApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SupportApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SupportApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SupportApiService,
    factory: SupportApiService.ɵfac,
    providedIn: 'root'
  });
  return SupportApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Article, Attachment, CreateTicketRequest, CreateTicketResponse, GetArticleRequest, GetArticleResponse, GetUserByPhoneRequest, GetUserByPhoneResponse, Group, ListCommentsRequest, ListCommentsResponse, ListTicketsRequest, ListTicketsResponse, SearchTicketsRequest, SearchTicketsResponse, SortBy, SortOrder, Status, SupportApiService, Ticket, TicketComment, User, Via };
